import React from "react"
import SingleQARTask from './SingleQARTask'
import RequestLicenseTask from './RequestLicenseTask'
import BulkUpdateButton from './BulkUpdateButton'
import LoadingIcon from '../formFields/LoadingIcon'
import ApproveSiteTask from "./ApproveSiteTask";
import ApproveChangeTask from "./ApproveChangeTask";
import PowerAppChangeTask from "./PowerAppChangeTask";
import PowerAppSolutionChangeTask from "./PowerAppSolutionChangeTask"
import PowerAppEnvironmentChangeTask from "./PowerAppEnvironmentChangeTask"

const MyTasks = ({ qarTasks, newSitesTasks, changeSiteTasks, licenseTasks, powerAppChanges, refresh, bulkApproveQARTasks, isTasksLoading, updateTasksCount, powerAppSolutionChanges, powerAppEnvironmentChanges, getCallback }) => {

    // useEffect(() => {
    //     if (!isTasksLoading)
    //         updateTasksCount(qarTasks.length + newSitesTasks.length + changeSiteTasks.length + licenseTasks.length + powerAppChanges.length + powerAppSolutionChanges.length)
    // }, [qarTasks, newSitesTasks, changeSiteTasks, licenseTasks, powerAppChanges, powerAppSolutionChanges])

    const myQARTasks = qarTasks.map(s =>
        <SingleQARTask
            key={s.id}
            element={s}
            refresh={refresh}
            created={s.created}
        />);

    const myLicenseTasks = licenseTasks.map(t =>
        <RequestLicenseTask
            key={t.id}
            task={t}
            refresh={refresh}
            created={t.created}
        />);

    const createSiteTasks = newSitesTasks.map(s =>
        <ApproveSiteTask
            key={s.id}
            site={s}
            refresh={refresh}
            created={s.created}
        />
    )

    const siteChangeTasks = changeSiteTasks.map(t =>
        <ApproveChangeTask
            key={t.id}
            change={t}
            refresh={refresh}
            created={t.requestDate}
        />
    )

    const powerAppChangesTasks = powerAppChanges.map(t =>
        <PowerAppChangeTask
            key={t.id}
            change={t}
            refresh={refresh}
            created={t.requestDate}
            getCallback={getCallback}
        />
    )

    const powerAppSolutioChangeTasks = powerAppSolutionChanges.map(t =>
        <PowerAppSolutionChangeTask
            key={t.id}
            change={t}
            refresh={refresh}
            created={t.requestDate}
            getCallback={getCallback}
        />
    )

    const powerAppEnvironmentChangeTasks = powerAppEnvironmentChanges.map(t =>
        <PowerAppEnvironmentChangeTask
            key={t.id}
            change={t}
            refresh={refresh}
            created={t.requestDate}
            getCallback={getCallback}
        />
    )

    const allTasks = [...myQARTasks, ...createSiteTasks, ...siteChangeTasks, ...myLicenseTasks, ...powerAppChangesTasks, ...powerAppSolutioChangeTasks, ...powerAppEnvironmentChangeTasks]
                    .sort((a, b) => (new Date(b.props.created) - new Date(a.props.created)))

    return (
        <div>
            {
                myQARTasks.length >= 50 &&
                <BulkUpdateButton
                    onApprove={bulkApproveQARTasks}
                    myQARTasksCount={myQARTasks.length}
                />
            }
            {
                isTasksLoading
                    ? <LoadingIcon />
                    : <div style={pivotItemStyles}>{allTasks}</div>
            }
        </div>
    )
}

const pivotItemStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%"
}

export default MyTasks


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyTasks.js